import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.AuditContactTypeEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    auditContactTypeEnumList: { items: data, total },
  } = await sdk.getListAuditContactTypeEnum(
    filterSortPage({
      sort,
      pagination,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { auditContactTypeEnum: data } = await sdk.getOneAuditContactTypeEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { auditContactTypeEnumMany: data } =
    await sdk.getManyAuditContactTypeEnum({
      ids,
    });

  return {
    data,
  };
}

/*********************************************************************/
export const auditContactTypeEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
